module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form form-horizontal"
  }, [_c('h4', [_vm._v("Historic Artifacts")]), _vm._v(" "), _vm._l((_vm.artifactCategoryList), function(category) {
    return _c('div', {
      key: category.index,
      staticClass: "col-md-2"
    }, [_c('label', [_vm._v(_vm._s(category.description))]), _vm._v(" "), _c('ul', {
      staticStyle: {
        "padding-left": "0px"
      },
      attrs: {
        "type": "none"
      }
    }, _vm._l((_vm.artifactList.filter(function (x) {
      return x.artifactCategoryId === category.artifactCategoryId
    })), function(artifact) {
      return _c('li', {
        key: artifact.artifactId
      }, [_c('div', {
        staticClass: "checkbox checkbox-inline"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedList),
          expression: "selectedList"
        }],
        attrs: {
          "type": "checkbox",
          "id": artifact.artifactId
        },
        domProps: {
          "value": artifact.artifactId,
          "checked": Array.isArray(_vm.selectedList) ? _vm._i(_vm.selectedList, artifact.artifactId) > -1 : (_vm.selectedList)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.selectedList,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = artifact.artifactId,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.selectedList = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.selectedList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.selectedList = $$c
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": artifact.artifactId
        }
      }, [_vm._v(_vm._s(artifact.description))])])])
    }))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a0c5124"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HistoricArtifactSelection.vue
// module id = 953
// module chunks = 1